module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/InglouriousBasterds.687b962.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/InglouriousBasterds.jpg
// module id = 81Ak
// module chunks = 0